// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders and matches snapshot 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
      >
        <div
          class="MuiGrid-root MuiGrid-container"
        >
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8"
          >
            <p
              class="MuiBox-root MuiBox-root-1"
            >
              12345
              : 
              Option 1
            </p>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4"
          >
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-flex-end"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root"
                focusable="false"
                style="color: rgb(189, 189, 189);"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
    >
      <div
        class="MuiGrid-root MuiGrid-container"
      >
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8"
        >
          <p
            class="MuiBox-root MuiBox-root-1"
          >
            12345
            : 
            Option 1
          </p>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4"
        >
          <div
            class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-flex-end"
          >
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root"
              focusable="false"
              style="color: rgb(189, 189, 189);"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
